import { z } from "zod";
import { safeHttpUrlSchema } from "../safe-url";

export const publicationTypeEnum = z.enum([
  "journal",
  "conference",
  "book_chapter",
  "thesis",
  "preprint",
  "other",
]);

export type PublicationType = z.infer<typeof publicationTypeEnum>;

export const publicationItemSchema = z.object({
  id: z.string().optional(),
  title: z.string().min(1, "Title is required").max(500, "Title too long"),
  authors: z.string().min(1, "Authors required").max(1000, "Authors list too long"),
  year: z.number().int().min(1900, "Year must be >= 1900").max(2100, "Year must be <= 2100"),
  venue: z.string().max(500, "Venue too long").optional().nullable(),
  type: publicationTypeEnum.default("journal"),
  doi: z.string().max(500, "DOI too long").optional().nullable(),
  url: safeHttpUrlSchema.optional().or(z.literal("")).nullable(),
  pdfUrl: safeHttpUrlSchema.optional().or(z.literal("")).nullable(),
  codeUrl: safeHttpUrlSchema.optional().or(z.literal("")).nullable(),
  abstract: z.string().max(3000, "Abstract too long").optional().nullable(),
  citationCount: z.number().int().nonnegative().optional().nullable(),
  featured: z.boolean().default(false).optional(),
});

export type PublicationItem = z.infer<typeof publicationItemSchema>;

import { getSectionDisplayOptionsSchema } from "../display-options";

export const publicationsDisplayOptionsSchema = getSectionDisplayOptionsSchema("publications");
export type PublicationsDisplayOptions = z.infer<typeof publicationsDisplayOptionsSchema>;

export const publicationsContentSchema = z.object({
  heading: z.string().max(200).default("Publications").optional(),
  displayStyle: z
    .enum(["grouped_by_year", "grouped_by_type", "list"])
    .default("grouped_by_year"),
  items: z.array(publicationItemSchema).max(200, "Maximum 200 publications allowed"),
  displayOptions: publicationsDisplayOptionsSchema.optional(),
});

export type PublicationsContent = z.infer<typeof publicationsContentSchema>;
